import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import TransporterReducer from './reducer';
const Transporter = combineReducers({
  transporters: TransporterReducer,
  form: formReducer
});


export default Transporter;
